export default __webpack_public_path__ + "static/media/reservation-img.22eed1c1.png";